/**
 * Financial display helpers. Verified peer amounts are USD cents; formatMoneyFromCents divides by 100.
 */

export function formatMoneyFromCents(cents) {
  if (cents == null || Number.isNaN(Number(cents))) return "—";
  const usd = Number(cents) / 100;
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
  }).format(usd);
}

/** @param {number|null|undefined} value Already in display percent (e.g. 12.5 means 12.5%) */
export function formatPercent(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const v = Number(value);
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(1)}%`;
}

export function formatCompactNumber(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const v = Number(value);
  if (Math.abs(v) >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1)}B`;
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (Math.abs(v) >= 1000) return `${(v / 1000).toFixed(1)}k`;
  return String(Math.round(v));
}

/** @param {number} mrrCents MRR in USD cents */
export function getMrrTier(mrrCents) {
  const c = Number(mrrCents) || 0;
  if (c >= 1_000_000) return { key: "10k", label: "$10k+ MRR" };
  if (c >= 500_000) return { key: "5k", label: "$5k+ MRR" };
  if (c >= 100_000) return { key: "1k", label: "$1k+ MRR" };
  return { key: "sub", label: "" };
}
